<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.qr_payment">
    <div *ngIf="businessId != '' && businessId != '0'">
        <div class="banner center" style="max-width:1200px;">
            <div class="row row_header freeze_height">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-8">
                            {{localService.languageContent.qr_payment.amount}}
                            &nbsp;/&nbsp;
                            {{localService.languageContent.qr_payment.status}}
                        </div>
                        <div class="col-4">
                            {{localService.languageContent.qr_payment.ref_num}}
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-8">
                            {{localService.languageContent.qr_payment.title}}
                        </div>
                        <div class="col-4">
                            {{localService.languageContent.qr_payment.for}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div *ngIf="(source && source.items.length > 0)" class="item-found">
                    <div class="row styled_row" *ngFor="let item of source.items">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-8">
                                    <span class="en">
                                        {{item.v2}}
                                        &nbsp;/&nbsp;
                                        {{localService.getText(localService.qrPaymentStatus,item.v3)}}
                                    </span>
                                </div>
                                <div class="col-4">
                                    <span class="en">
                                        {{item.v1}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-8">
                                    <span>
                                        {{item.v7}}
                                    </span>
                                </div>
                                <div class="col-4">
                                    <span *ngIf="item.v5 == '2'">{{item.v6}}</span>
                                    <span class="button en" *ngIf="item.v5 != '2'"
                                        (click)="onAction(1,item.key)">{{item.v6}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-paging *ngIf="source && source.paging" [paging]="source.paging"
            (onPagingRefreshed)="onLoad()"></app-paging>
    </div>
</div>